export const tmp = null;
export const heightBreak = '@media screen and (min-height: 800px)';
